import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['video']

  pause() {
    this.videoTarget.pause()
  }

  play() {
    this.videoTarget.play()
  }
}
